/**
 * [MCV-1494] Tab indices for the provider Settings page, shared by `Settings`
 * (which renders them) and by anything that deep-links back with `?tab=`.
 * Named so inserting a tab can't silently send a callback to the wrong panel.
 */
export const SETTINGS_TABS = {
  account: 0,
  employerAssociation: 1,
} as const;
